import React from 'react';
import PopupAlert from './PopupAlert';

const PhantomAutoconnectAlert = (props: { onSeen?: () => void }) => {
	return (
		<PopupAlert
			heading={'Phantom Auto-Confirm is now available'}
			featureKey={'phantomAutoconnect'}
			onSeen={props.onSeen}
		>
			<>
				<span>
					Phantom Auto-Confirm is available for Drift! Now you can trade faster
					with fewer clicks if you turn on auto-confirm in your Phantom Wallet
					settings.{' '}
					<a
						href={`https://phantom.app/learn/blog/auto-confirm`}
						target="_blank"
						rel="noreferrer"
						className="inline-flex items-center"
					>
						Click here
					</a>{' '}
					for a step-by-step guide.
				</span>
			</>
		</PopupAlert>
	);
};

export default PhantomAutoconnectAlert;
